import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedSection from './components/FeaturedSection';
import TrendingSection from './components/TrendingSection';
import NewReleasesSection from './components/NewReleasesSection';

export default function Home() {
  return (
    <main>
      <HeroSection />
      <CategoryNav />
      <FeaturedSection />
      <TrendingSection />
      <NewReleasesSection />
    </main>
  );
}